<cs-modal [settings]="settingsModal"></cs-modal>
<cs-modal [settings]="settingsAcceptanceLegalModal"></cs-modal>
<app-env-indicator></app-env-indicator>
<app-legal-terms-top-notice-bar></app-legal-terms-top-notice-bar>

<div class="page">
    <router-outlet></router-outlet>
    <app-network-connection></app-network-connection>
</div>